import { AppNavigationProvider } from '@euler/app/components/AppNavigationProvider';
import { BackIcon } from '@euler/app/components/icons/BackIcon';
import { ReworkRecordScreens } from '@euler/app/flows/task/pages/delivery-check/rework-record/screens';
import { BackButton } from '@euler/app/flows/task/pages/inspection/site-inspection/BackButton';
import { LayoutProviderView } from '@euler/components/layout/LayoutProvider';
import { MultilineHeaderTitle } from '@euler/components/MultilineHeaderTitle';
import { FontFamily } from '@euler/components/typography';
import { useTrackNavigator } from '@euler/functions/navigatorTracking';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { spreadScreens } from '@euler/functions/spreadScreens';
import { ReworkRecordStaged } from '@euler/model/task-detail/ReworkRecord';
import { NavigationContainer } from '@react-navigation/native';
import {
  createStackNavigator,
  TransitionPresets,
} from '@react-navigation/stack';
import { memo } from 'react';

const Stack = createStackNavigator();

export const ReworkRecordFlowNavigator = memo(
  (props: {
    recordInfo: ReworkRecordStaged;
    onKeywordInputFocus?: () => void;
    onCancel?: () => void;
    onDone?: (record: ReworkRecordStaged) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { ref, onStateChange, onReady } = useTrackNavigator('rework-record/');

    return (
      <AppNavigationProvider>
        <LayoutProviderView
          fallbackToChildren
          style={{ flex: 1, justifyContent: 'flex-start' }}
        >
          <NavigationContainer
            documentTitle={{ enabled: false }}
            ref={ref}
            onReady={onReady}
            onStateChange={onStateChange}
            independent={true}
            onUnhandledAction={action => {
              if (action.type === 'POP') {
                props.onCancel?.();
              }
            }}
          >
            <Stack.Navigator
              initialRouteName="_record"
              screenOptions={{
                ...TransitionPresets.SlideFromRightIOS,
                headerStatusBarHeight: 0,
                headerMode: 'float',
                headerTitleAlign: 'center',
                headerBackTitle: ' ',
                headerTitleStyle: {
                  fontSize: rpx(18),
                  fontFamily: FontFamily.NotoSans.Bold,
                },
                cardStyle: {
                  backgroundColor: '#fff',
                },
                headerTitle: MultilineHeaderTitle,
                headerLeft: () => (
                  <BackButton>
                    <BackIcon />
                  </BackButton>
                ),
              }}
            >
              {spreadScreens(
                Stack.Screen,
                ReworkRecordScreens,
                '_record',
                props,
              )}
            </Stack.Navigator>
          </NavigationContainer>
        </LayoutProviderView>
      </AppNavigationProvider>
    );
  },
);
